import { useQuery } from '@tanstack/react-query';
import UserPermissionsService from '../../services/user-permissions';

export const USER_PUBLISH_ACCESS_QUERY_KEY = ['UserPublishAccess'];

export const useUserPublishAccessQuery = () => {
  return useQuery<boolean, Error>({
    queryKey: USER_PUBLISH_ACCESS_QUERY_KEY,
    queryFn: async () => {
      const service = new UserPermissionsService();
      const response = await service.getPublishAccess();
      return response.data.publish_access ?? false;
    },
    meta: { persist: false },
  });
};
